import useConfiguration from '@store/hooks/useConfiguration';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { ILinks } from './types';

interface IProps extends ILinks {
  basketName: string;
  hasLines: boolean;
}

export default function Buttons(props: IProps) {
  const { xsrf } = useConfiguration();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col tablet:flex-row tablet:items-end tablet:justify-between gap-2 border-b-2 tablet:pb-2">
      <form className="form flex gap-x-2 items-end" method="post">
        <div>
          <label htmlFor="basketName">{t('BasketName')}</label>
          <div>
            <input
              type="text"
              className="input"
              id="basketName"
              name="basketName"
              required
              defaultValue={props.basketName}
            />
          </div>
        </div>
        <div>
          <input type="hidden" name="__RequestVerificationToken" defaultValue={xsrf} />
          <button type="submit" className="btn btn-dark">
            <span className="icon hidden tablet:block laptop:hidden">
              <i className="fa-solid fa-save" />
            </span>
            <span className="tablet:hidden laptop:block">{t('ToRename')}</span>
          </button>
        </div>
      </form>
      <div>
        <ul className="w-full flex gap-x-2 text-sm">
          <li className="grow">
            <a
              className="inline-flex py-2 px-2 font-medium text-black hover:underline"
              href={props.carts}>
              <span className="icon mr-2">
                <i className="fa-solid fa-cart-shopping" />
              </span>
              {t('Title.Baskets')}
            </a>
          </li>
          <li className="grow">
            <a
              className="inline-flex py-2 px-2 font-medium text-green-600 hover:underline"
              href={props.select}>
              <span className="icon mr-2">
                <i className="fa-solid fa-arrow-pointer" />
              </span>
              {t('SelectBasket')}
            </a>
          </li>
          {props.hasLines && (
            <li className="grow">
              <a
                className="inline-flex py-2 px-2 font-medium text-blue-600 hover:underline"
                href={props.clone}>
                <span className="icon mr-2">
                  <i className="fa-solid fa-clone" />
                </span>
                {t('CloneBasket')}
              </a>
            </li>
          )}
          {props.hasLines && (
            <li className="grow">
              <a
                className="inline-flex py-2 px-2 font-medium text-red-600 hover:underline"
                href={props.truncate}>
                <span className="icon mr-2">
                  <i className="fa-solid fa-trash" />
                </span>
                {t('ClearBasket')}
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}
